<div class="n-card-proposal">
  <!-- Top Header Row -->
  <div class="n-header-row flex align-items-center justify-content-between gap-2">
    <!-- Avatar + Client Info -->
    <div class="flex align-items-center gap-3 min-w-0 flex-1">
      <div class="n-avatar-squircle flex align-items-center justify-content-center flex-shrink-0" [style.background-color]="getAvatarColor(cliente.id)">
        {{ getIniciais(cliente.nome) }}
      </div>
      <div class="flex flex-column min-w-0">
        <h3 class="n-cliente-nome m-0 text-overflow-ellipsis overflow-hidden white-space-nowrap" [title]="cliente.nome">
          {{ cliente.nome }}
        </h3>
        <span class="n-cliente-status text-xs">{{ 'BARDO_CLIENTES.CLIENTE_ATIVO' | translate: { termo: $nicho().cliente.singular } }}</span>
      </div>
    </div>

    <!-- Delete Button Pill -->
    @if (possuiPermissao('Bardo.cliente.delete')) {
      <button
        type="button"
        class="n-btn-excluir flex align-items-center gap-1 cursor-pointer border-none flex-shrink-0"
        (click)="confirmarExclusao(cliente, $event)"
        [title]="'GLOBAL.EXCLUIR' | translate"
      >
        <i class="pi pi-trash text-xs"></i>
        <span>{{ 'GLOBAL.EXCLUIR' | translate }}</span>
      </button>
    }
  </div>

  <!-- Stat Cards Row (Strictly 3 columns on Mobile & Desktop) -->
  <div class="n-metricas-grid mt-4">
    @if (carregandoMetricas()) {
      <div class="n-metricas-loading">
        <i class="pi pi-spin pi-spinner"></i>
      </div>
    } @else {
      <!-- CANCELADOS -->
      <div class="n-stat-card cancelados">
        <span class="n-stat-label">{{ 'BARDO_CLIENTES.METRICAS.CANC' | translate }}</span>
        <span class="n-stat-value text-red">{{ formatarZeroEsquerda(metricas.cancelados) }}</span>
      </div>

      <!-- ATENDIDOS -->
      <div class="n-stat-card atendidos highlighted">
        <span class="n-stat-label text-purple">{{ 'BARDO_CLIENTES.METRICAS.ATEND' | translate }}</span>
        <span class="n-stat-value text-purple">{{ formatarZeroEsquerda(metricas.atendidos) }}</span>
      </div>

      <!-- CONFIRMADOS -->
      <div class="n-stat-card confirmados">
        <span class="n-stat-label">{{ 'BARDO_CLIENTES.METRICAS.CONF' | translate }}</span>
        <span class="n-stat-value text-green">{{ formatarZeroEsquerda(metricas.confirmados) }}</span>
      </div>
    }
  </div>

  <!-- Services Section -->
  @if (!carregandoMetricas()) {
    <div class="n-servicos-section mt-4">
      <div class="n-section-title-container flex align-items-center gap-2 mb-3">
        <span class="n-section-title text-xs font-bold uppercase tracking-wider">{{ 'BARDO_CLIENTES.SERVICOS_MAIS_USADOS' | translate }}</span>
        <div class="n-title-line flex-1"></div>
      </div>

      @if (metricas.servicosMaisUtilizados && metricas.servicosMaisUtilizados.length > 0) {
        <div class="n-servicos-list flex flex-column gap-2">
          @for (servico of servicosLista(); track servico.nome; let idx = $index) {
            <div class="n-servico-pill-item flex align-items-center justify-content-between p-3">
              <div class="flex align-items-center gap-2 min-w-0">
                <span class="n-servico-dot flex-shrink-0" [class.highlight]="idx === 0"></span>
                <span class="n-servico-name font-semibold text-sm text-overflow-ellipsis overflow-hidden white-space-nowrap">
                  {{ servico.nome }}
                </span>
              </div>
              <span class="n-servico-badge text-xs font-semibold flex-shrink-0 ml-2">
                {{ formatarCount(servico.count) }}
              </span>
            </div>
          }
        </div>
      } @else {
        <div class="n-empty-servicos text-center py-3 text-500 text-sm border-round-lg">
          {{ 'BARDO_CLIENTES.NENHUM_ATENDIMENTO_REGISTRADO' | translate }}
        </div>
      }
    </div>

    <!-- Bottom Footer Button -->
    <div class="n-footer-action mt-4 pt-2">
      <button
        type="button"
        class="n-btn-historico w-full py-3 px-4 font-bold text-sm cursor-pointer"
        (click)="abrirHistoricoModal()"
      >
        {{ 'BARDO_CLIENTES.VER_HISTORICO_COMPLETO' | translate }}
      </button>
    </div>
  }
</div>

<!-- Modal / Dialog de Histórico Completo (Desktop) -->
@if (!deviceService.$isMobile()) {
  <p-dialog
    [header]="'BARDO_CLIENTES.HISTORICO_ATENDIMENTOS_DE' | translate: { nome: cliente.nome }"
    [(visible)]="modalHistoricoAberto"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '560px', maxWidth: '95vw' }"
  >
    @if (modalHistoricoAberto()) {
      <lib-cliente-historico [cliente]="cliente"></lib-cliente-historico>
    }
  </p-dialog>
} @else {
  <!-- Bottom Sheet de Histórico Completo (Mobile) -->
  @if (modalHistoricoAberto()) {
    <lib-bottom-sheet
      [visible]="modalHistoricoAberto()"
      (visibleChange)="modalHistoricoAberto.set($event)"
      size="full"
      [draggable]="true"
      [closeOnBackdrop]="true"
      [closeOnEscape]="true"
      [headerTemplate]="headerHistoricoTemplate"
      (hide)="modalHistoricoAberto.set(false)"
    >
      <lib-cliente-historico [cliente]="cliente"></lib-cliente-historico>
    </lib-bottom-sheet>
  }

  <ng-template #headerHistoricoTemplate>
    <div class="flex align-items-center justify-content-between w-full">
      <h3 class="m-0 font-semibold text-lg">{{ 'BARDO_CLIENTES.HISTORICO_ATENDIMENTOS' | translate }}</h3>
    </div>
  </ng-template>
}


<!-- Mobile Bottom Sheet para Confirmar Exclusão de Cliente -->
@if (deviceService.$isMobile() && modalExclusaoAberto()) {
  <lib-bottom-sheet
    [visible]="modalExclusaoAberto()"
    (visibleChange)="modalExclusaoAberto.set($event)"
    size="medium"
    [draggable]="true"
    [closeOnBackdrop]="!excluindo()"
    [closeOnEscape]="!excluindo()"
    [preventClose]="excluindo()"
    [headerTemplate]="headerExcluirTemplate"
    [footerTemplate]="footerExcluirTemplate"
    (hide)="modalExclusaoAberto.set(false)"
  >
    <div class="flex flex-column align-items-center text-center py-3 px-2 gap-3">
      <div class="w-3rem h-3rem border-circle bg-red-100 flex align-items-center justify-content-center">
        <i class="pi pi-exclamation-triangle text-red-600 text-2xl"></i>
      </div>
      <p class="m-0 text-700 text-base line-height-3" [innerHTML]="'BARDO_CLIENTES.CONFIRMAR_EXCLUSAO_MSG' | translate: { termo: ($nicho().cliente.singular | lowercase), nome: cliente.nome }">
      </p>
    </div>
  </lib-bottom-sheet>
}

<ng-template #headerExcluirTemplate>
  <div class="flex align-items-center justify-content-between w-full">
    <h3 class="m-0 font-semibold text-lg">{{ 'GLOBAL.CONFIRMAR_EXCLUSAO' | translate }}</h3>
  </div>
</ng-template>

<ng-template #footerExcluirTemplate>
  <div class="flex gap-2 w-full pt-2">
    <p-button
      [label]="'GLOBAL.CANCELAR' | translate"
      severity="secondary"
      [outlined]="true"
      styleClass="w-full"
      (onClick)="modalExclusaoAberto.set(false)"
      [disabled]="excluindo()"
    />
    <p-button
      [label]="'GLOBAL.SIM_EXCLUIR' | translate"
      severity="danger"
      styleClass="w-full"
      icon="pi pi-trash"
      [loading]="excluindo()"
      (onClick)="excluirCliente(cliente.id)"
    />
  </div>
</ng-template>

